<template>
  <el-container style="height: 100%;">
    <el-header height="40">
        <el-button
            @click="formAdd(1)"
            style="margin:10px 0px 10px 0px;"
            size="small"
            type="primary"
            icon="el-icon-plus"
            plain
            >新增</el-button>
            <!-- 暂时不可搜 -->
        <!-- <el-input
            placeholder="请输入子目名称搜索"
            v-model="filterName"
            class="input-with-select"
            size="small"
            style="width: 250px; float: right; margin-top: 9px"
            clearable>
        <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
        </el-input> -->
    </el-header>
    <el-main class="nopadding">
        <el-table
          border
          stripe
          size="small"
          ref="singleTable"
          :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
          :data="tableData"
          :highlight-current-row="true"
          >
          <el-table-column property="code" label="类型编码" width="100"></el-table-column>
          <!-- <el-table-column property="id" label="id"></el-table-column> -->
          <el-table-column property="name" align="center"  width="180" label="名称"></el-table-column>
          <el-table-column property="url" align="center" label="地址"></el-table-column>
          <el-table-column property="inputDate" align="center"  width="120" label="录入时间"></el-table-column>
          <el-table-column align="center" width="100" label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-edit"
                title="编辑"
                circle
                plain
                @click="formEdit(scope.$index, scope.row)"></el-button>
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                title="删除"
                circle
                plain
                @click="formDelete(scope.$index, scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[15]"
            :page-size="rows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
    </el-main>
    <el-dialog title="配置信息" width="50%" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
      <el-form :model="configeForm"  :rules="rules" ref="configeForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="类型编码" prop="code" :label-width="formLabelWidth">
              <el-input v-model="configeForm.code" placeholder="请填写类型编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="地址" prop="url" :label-width="formLabelWidth">
              <el-input v-model="configeForm.url" placeholder="请填写地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <el-col :span="24">
            <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
              <el-input v-model="configeForm.name" placeholder="请填写名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="formSave('configeForm')">保 存</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import {getWarnconfig,saveconfig,deleteconfig} from '../api/warnMessage'
export default {
  name: 'warnManage',
  data () {
    return {
      filterName: "",
      tableData: [],
      dialogFormVisible: false,
      dialogRolesVisible: false,
      configeForm: {
        code:'',
        url:'',
        name:''
      },
      formLabelWidth: '90px',
      total: 0,
      rows: 15,
      currentPage: 1,
      selectResourceId: '',
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
         code: [
          { required: true, message: '请输入编码', trigger: 'blur' },
        ],
         url: [
          { required: true, message: '请输入地址', trigger: 'blur' },
        ],
      }
    }
  },
  mounted: function () {
    this.getList();
  },
  methods: {
    handleSizeChange (val) {
      this.rows = val
      this.currentPage = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    getList: function () {
      getWarnconfig()
      .then(res=>{
        if(res.success){
          this.tableData = res.data.rows
          this.total = res.data.total
        }
        console.log(res)
       }).catch(error => {
        console.log("error:" + error.toString());
      })

    },
    formAdd () {
      if (this.$refs.configeForm) {
        this.$refs.configeForm.clearValidate()
      }
      this.configeForm = {}
      this.dialogFormVisible = true
    },
    formSave (configeForm) { // 保存节点
    console.log(3330)
      this.$refs[configeForm].validate((valid) => {
        if (valid) {
          saveconfig(this.configeForm)
          .then(res=>{
            if(res.success){
            this.configeForm = {};
            this.dialogFormVisible = false
            this.getList()
            }else{
              this.$message({
                message: res.msg,
                showClose: true,
                type: 'error'
              })
            }
            console.log(res)
          })

        } else {
          return false
        }
      })
    },
    // 编辑
    formEdit (index, row) {
      console.log(row)
      if (this.$refs.configeForm) {
        this.$refs.configeForm.clearValidate()
      }
      this.configeForm = row;
      // this.getFilesData(row.id);
      // this.getFilesData(row.id,"1");
      this.dialogFormVisible = true;
    },
    formDelete (index, row) {
      this.$confirm('是否删除?', '提示', {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteconfig({id:row.id})
       .then(data => {
          if (data.succeed) {
            this.getList();
          } else {
            this.$message({
              message: data.msg,
              showClose: true,
              type: 'error'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          showClose: true,
          message: '已取消删除'
        })
      })
    },

    //获取table数据
    getFilesData(bizPk,type) {
      if(type=="1"){
        this.fileList4 =[];
        this.$axios.post('/api/loginConfig/getQrCode/'+bizPk).then(res => {
          if(res){
            var item = {
              name: 'APK',
              url: res.data
            };
            // console.log(res.data);
            this.fileList4.push(item);
          }
        }).catch(error => {
            console.log('error:' + error.toString())
        })
      }else{
        if(type=="homeLogoUrl"){
          this.fileList1 =[];
        }else if(type=="sloganUrl"){
          this.fileList2 =[];
        }else if(type=="loginLogoUrl"){
          this.fileList3 =[];
        }
        let params = {
          'metaData.formId': bizPk,
          'metaData.fileType': type
        }
        this.$axios.post('/api/fs/files/search',this.$qs.stringify(params)).then(res => {
          if(res.data && res.data.length>0){
            res.data.map((item,index)=>{
              item.name = item.metaData.fileName;
              item.url = "/api/fs/files/download/"+item.id;
              if(item.metaData.fileType=="homeLogoUrl"){
                this.fileList1.push(item);
              }else if(item.metaData.fileType=="sloganUrl"){
                this.fileList2.push(item);
              }else if(item.metaData.fileType=="loginLogoUrl"){
                this.fileList3.push(item);
              }
            })
          }
        }).catch(error => {
            console.log('error:' + error.toString())
        })
      }
      
    },
  }
}
</script>

<style scoped>
  .nopadding {
      padding: 0 20px;
  }
  .el-upload__tip{
    color: red;
    margin-top: 0;
    line-height: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/views/warnManage.vue